import Image from 'next/image'
import { DiagonalLine, BuildAndScaleLines } from '@icons'
import { forwardRef } from 'react'

import { CTAButton } from '../../button'
import BuildAndScaleImage from '../../../assets/pngs/build-and-scale.png'

import styles from './styles.module.scss'

export const BuildAndScaleSection = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section className={styles['build-and-scale-section']} ref={ref}>
      <div className={styles['build-and-scale-wrapper']}>
        <DiagonalLine className={styles['diagonal-line']} />
        <div className={styles['build-and-scale-content']}>
          <h1 className={styles['section-title']}>
            <span className={styles['text-decorator']}>Build and scale</span> your tech team
          </h1>
          <p className={styles['section-text']}>
            We provide on-demand, engaged tech talent from Brazil for enterprises and growing
            startups.
          </p>
        </div>
        <CTAButton
          href="/companies"
          variant="secondary"
          className={styles['button']}
          prefetch={false}
        >
          hire Olby
        </CTAButton>
        <CTAButton
          href="/companies"
          variant="secondary"
          className={styles['button-mobile']}
          prefetch={false}
          size="medium"
        >
          hire Olby
        </CTAButton>
        <div className={styles['image-container']}>
          <div>
            <Image
              src={BuildAndScaleImage}
              className={styles['image']}
              fill
              sizes="(max-width: 703px) 22.3rem, (max-width: 1279px) 36.5rem, 47.5rem"
              alt="Three people working on a desk"
            />
          </div>
          <BuildAndScaleLines className={styles['lines']} />
        </div>
      </div>
    </section>
  )
})

export default BuildAndScaleSection
